import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledSalesforceActivityBannerFlex = styled(Flex)`
    width: 100%;
    margin-bottom: 4px;
    padding: 8px 16px;
    border-radius: 3px;
    background-color: ${colorsPalettes.bluegrey["200"]};
`;
